const createAdminRouter = (prefix: string, routerName: string, key: string = 'id') => {
    return {
        name: prefix + routerName + "/",
        list: "/" + prefix + routerName + '/list',
        add: "/" + prefix + routerName + '/add',
        edit: "/" + prefix + routerName + '/edit/:' + key,
        detail: "/" + prefix + routerName + '/detail/:' + key,
    }
}

const routerConstants = {
    public: {
    },
    audit: {
        ...createAdminRouter('admin/', 'audit'),
    },
    
    user: {
        ...createAdminRouter('admin/', 'user'),
        changePWD: '/admin/user/doi-mat-khau'
    },

    notification: {
        ...createAdminRouter('', 'notification'),
        list: '/admin/notification/list',
        add: '/admin/notification/add',
        edit: '/admin/notification/edit/:id',
        detail: '/admin/notification/detail/:id',
        import: '/admin/notification/import',
        send: '/admin/notification/send',
    },

    mangXaHoi: {
        ...createAdminRouter('', 'mang-xa-hoi'),
        list: '/mang-xa-hoi/ban-tin',
        detail: '/mang-xa-hoi/chi-tiet/:id',
    },
    nhanSu: {
        hoSoNhanVien: {
            ...createAdminRouter('nhan-su/', 'ho-so-nhan-vien', 'userId'),
        },
        giaDinh: {
            list: '/nhan-su/gia-dinh/danh-sach/:userId',
            add: '/nhan-su/gia-dinh/them/:userId',
            edit: '/nhan-su/gia-dinh/cap-nhat/:userId/:id',
            detail: '/nhan-su/gia-dinh/chi-tiet/:userId/:id',
        },
        taiLieu: {
            list: '/nhan-su/tai-lieu/danh-sach/:userId',
            add: '/nhan-su/tai-lieu/them/:userId',
            edit: '/nhan-su/tai-lieu/cap-nhat/:userId/:id',
            detail: '/nhan-su/tai-lieu/chi-tiet/:userId/:id',
        },
        hopDong: {
            list: '/nhan-su/hop-dong/danh-sach/:userId',
            add: '/nhan-su/hop-dong/them/:userId',
            edit: '/nhan-su/hop-dong/cap-nhat/:userId/:id',
            detail: '/nhan-su/hop-dong/chi-tiet/:userId/:id',
        },
        phuLucHopDong: {
            list: '/nhan-su/phu-luc-hop-dong/danh-sach/:contractId',
            add: '/nhan-su/phu-luc-hop-dong/them/:contractId',
            edit: '/nhan-su/phu-luc-hop-dong/cap-nhat/:contractId/:id',
            detail: '/nhan-su/phu-luc-hop-dong/chi-tiet/:contractId/:id',
        },
        bangCap: {
            list: '/nhan-su/bang-cap/danh-sach/:userId',
            add: '/nhan-su/bang-cap/them/:userId',
            edit: '/nhan-su/bang-cap/cap-nhat/:userId/:id',
            detail: '/nhan-su/bang-cap/chi-tiet/:userId/:id',
        },
        baoHiem: {
            list: '/nhan-su/bao-hiem/danh-sach/:userId',
            add: '/nhan-su/bao-hiem/them/:userId',
            edit: '/nhan-su/bao-hiem/cap-nhat/:userId/:id',
            detail: '/nhan-su/bao-hiem/chi-tiet/:userId/:id',
        },
        thongTinCongViec: {
            list: '/nhan-su/thong-tin-cong-viec/danh-sach/:userId',
            add: '/nhan-su/thong-tin-cong-viec/them/:userId',
            edit: '/nhan-su/thong-tin-cong-viec/cap-nhat/:userId/:id',
            detail: '/nhan-su/thong-tin-cong-viec/chi-tiet/:userId/:id',
        },
        lichSuCongTac: {
            list: '/nhan-su/lich-su-cong-tac/danh-sach/:userId',
            add: '/nhan-su/lich-su-cong-tac/them/:userId',
            edit: '/nhan-su/lich-su-cong-tac/cap-nhat/:userId/:id',
            detail: '/nhan-su/lich-su-cong-tac/chi-tiet/:userId/:id',
        },
        khenThuong: {
            list: '/nhan-su/khen-thuong/danh-sach/:userId',
            add: '/nhan-su/khen-thuong/them/:userId',
            edit: '/nhan-su/khen-thuong/cap-nhat/:userId/:id',
            detail: '/nhan-su/khen-thuong/chi-tiet/:userId/:id',
        },
        kyLuat: {
            list: '/nhan-su/ky-luat/danh-sach/:userId',
            add: '/nhan-su/ky-luat/them/:userId',
            edit: '/nhan-su/ky-luat/cap-nhat/:userId/:id',
            detail: '/nhan-su/ky-luat/chi-tiet/:userId/:id',
        },
        daoTao: {
            list: '/nhan-su/dao-tao/danh-sach/:userId',
            add: '/nhan-su/dao-tao/them/:userId',
            edit: '/nhan-su/dao-tao/cap-nhat/:userId/:id',
            detail: '/nhan-su/dao-tao/chi-tiet/:userId/:id',
        },
        phuCap: {
            list: '/nhan-su/phu-cap/danh-sach/:userId',
            add: '/nhan-su/phu-cap/them/:userId',
            edit: '/nhan-su/phu-cap/cap-nhat/:userId/:id',
            detail: '/nhan-su/phu-cap/chi-tiet/:userId/:id',
        },
        thanhToanBaoHiem: {
            ...createAdminRouter('nhan-su/', 'thanh-toan-bao-hiem', 'id'),
        },
        quyenLoiBaoHiem: {
            ...createAdminRouter('nhan-su/', 'quyen-loi-bao-hiem', 'id'),
        },
        quyPhucLoi: {
            ...createAdminRouter('nhan-su/', 'quy-phuc-loi', 'id'),
        },
        phongBan: {
            ...createAdminRouter('nhan-su/', 'phong-ban', 'id'),
        },
        chucDanh: {
            ...createAdminRouter('nhan-su/', 'chuc-danh', 'id'),
        },
    },
    daoTao: {
        khoaHocDaoTao: {
            ...createAdminRouter('dao-tao/', 'khoa-hoc-dao-tao', 'id'),
        },
    },
    chamCong: {
        chamCong: '/cham-cong/cham-cong',
        lichSu: '/cham-cong/lich-su',
        trangChu: '/cham-cong/trang-chu',
        caLamViec: {
            ...createAdminRouter('cham-cong/', 'ca-lam-viec', 'id'),
        },
        lichPhanCa: {
            ...createAdminRouter('cham-cong/', 'lich-phan-ca', 'id'),
        },
        mauCa: {
            ...createAdminRouter('cham-cong/', 'mau-ca', 'id'),
        },
        chiTietCong: {
            ...createAdminRouter('cham-cong/', 'chi-tiet-cong', 'id'),
        },
        tongHopCong: {
            ...createAdminRouter('cham-cong/', 'tong-hop-cong', 'id'),
        },
        viTri: {
            ...createAdminRouter('cham-cong/', 'vi-tri', 'id'),
        },
        mangNoiBo: {
            ...createAdminRouter('cham-cong/', 'mang-noi-bo', 'id'),
        },
    },
    tuyenDung: {
        trangChu: {
            list: '/tuyen-dung/trang-chu',
        },
        yeuCauTuyenDung: {
            ...createAdminRouter('tuyen-dung/', 'yeu-cau-tuyen-dung', 'id'),
        },
        dangTuyen: {
            list: '/tuyen-dung/dang-tuyen/danh-sach/:recruitmentRequestId',
            listAll: '/tuyen-dung/dang-tuyen/danh-sach',
            add: '/tuyen-dung/dang-tuyen/them/:recruitmentRequestId',
            edit: '/tuyen-dung/dang-tuyen/cap-nhat/:recruitmentRequestId/:id',
            detail: '/tuyen-dung/dang-tuyen/chi-tiet/:recruitmentRequestId/:id',
            name: '/tuyen-dung/dang-tuyen/',
        },
        ungVien: {
            list: '/tuyen-dung/ung-vien/danh-sach/:recruitmentRequestId',
            listAll: '/tuyen-dung/ung-vien/danh-sach',
            add: '/tuyen-dung/ung-vien/them/:recruitmentRequestId',
            edit: '/tuyen-dung/ung-vien/cap-nhat/:recruitmentRequestId/:id',
            detail: '/tuyen-dung/ung-vien/chi-tiet/:recruitmentRequestId/:id',
            name: '/tuyen-dung/ung-vien/',
        },
        lichPhongVan: {
            list: '/tuyen-dung/lich-phong-van/danh-sach/:candidateId',
            listAll: '/tuyen-dung/lich-phong-van/danh-sach',
            add: '/tuyen-dung/lich-phong-van/them/:candidateId',
            edit: '/tuyen-dung/lich-phong-van/cap-nhat/:candidateId/:id',
            detail: '/tuyen-dung/lich-phong-van/chi-tiet/:candidateId/:id',
            name: '/tuyen-dung/lich-phong-van/',
        },
        thuMoiLamViec: {
            list: '/tuyen-dung/thu-moi-lam-viec/danh-sach/:candidateId',
            listAll: '/tuyen-dung/thu-moi-lam-viec/danh-sach',
            add: '/tuyen-dung/thu-moi-lam-viec/them/:candidateId',
            edit: '/tuyen-dung/thu-moi-lam-viec/cap-nhat/:candidateId/:id',
            detail: '/tuyen-dung/thu-moi-lam-viec/chi-tiet/:candidateId/:id',
            name: '/tuyen-dung/thu-moi-lam-viec/',
        },
        huongDanNhanViec: {
            list: '/tuyen-dung/huong-dan-nhan-viec/danh-sach/:candidateId',
            add: '/tuyen-dung/huong-dan-nhan-viec/them/:candidateId',
            edit: '/tuyen-dung/huong-dan-nhan-viec/cap-nhat/:candidateId/:id',
            detail: '/tuyen-dung/huong-dan-nhan-viec/chi-tiet/:candidateId/:id',
        },
    },
    hanhchinh: {
        trangChu: '/hanhchinh/trang-chu',
        taiSan: {
            ...createAdminRouter('hanhchinh/', 'tai-san', 'id'),
        },
        danhMucTaiSan: {
            ...createAdminRouter('hanhchinh/', 'danh-muc-tai-san', 'id'),
        },
        muonTraTaiSan: {
            name: '/hanhchinh/muon-tra-tai-san/',
            list: '/hanhchinh/muon-tra-tai-san/danh-sach',
            add: '/hanhchinh/muon-tra-tai-san/them',
            detail: '/hanhchinh/muon-tra-tai-san/chi-tiet/:id',
            tra: '/hanhchinh/muon-tra-tai-san/tra/:id',
            quaHan: '/hanhchinh/muon-tra-tai-san/qua-han',
        },
        baoDuong: {
            ...createAdminRouter('hanhchinh/', 'bao-duong', 'id'),
            sapToi: '/hanhchinh/bao-duong/sap-toi',
        },
        phongHop: {
            ...createAdminRouter('hanhchinh/', 'phong-hop', 'id'),
        },
        datLichHop: {
            ...createAdminRouter('hanhchinh/', 'dat-lich-hop', 'id'),
        },
        thanhPhanThamDu: {
            ...createAdminRouter('hanhchinh/', 'thanh-phan-tham-du', 'id'),
        },
        // Giữ lại administrative để tương thích ngược
        administrative: {
            dashboard: '/administrative/dashboard',
            asset: {
                ...createAdminRouter('administrative/', 'asset', 'id'),
            },
            assetCategory: {
                ...createAdminRouter('administrative/', 'asset-category', 'id'),
            },
            assetBorrowing: {
                name: '/administrative/asset-borrowing/',
                list: '/administrative/asset-borrowing/list',
                add: '/administrative/asset-borrowing/add',
                detail: '/administrative/asset-borrowing/detail/:id',
                return: '/administrative/asset-borrowing/return/:id',
                overdue: '/administrative/asset-borrowing/overdue',
            },
            maintenance: {
                upcoming: '/administrative/maintenance/upcoming',
            },
        },
    },
    hop: {
        phongHop: {
            ...createAdminRouter('hop/', 'phong-hop', 'id'),
        },
        datLichHop: {
            ...createAdminRouter('hop/', 'dat-lich-hop', 'id'),
        },
        thanhPhanThamDu: {
            ...createAdminRouter('hop/', 'thanh-phan-tham-du', 'id'),
        },
    },
    bangLuong: {
        thanhPhan: {
            ...createAdminRouter('bang-luong/', 'thanh-phan'),
        },
        kyLuong: {
            ...createAdminRouter('bang-luong/', 'ky-luong'),
        },
        bangLuong: {
            ...createAdminRouter('bang-luong/', 'bang-luong'),
            tinhToan: '/bang-luong/bang-luong/tinh-toan',
        },
        cauHinhLuong: {
            ...createAdminRouter('bang-luong/', 'cau-hinh-luong'),
        },
        baoCao: {
            tongHopQuy: '/bang-luong/bao-cao/tong-hop-quy',
            bienDongThuNhap: '/bang-luong/bao-cao/bien-dong-thu-nhap',
            chiPhiNhanSu: '/bang-luong/bao-cao/chi-phi-nhan-su',
            chiTiet: '/bang-luong/bao-cao/chi-tiet/:userId',
        },
        dongBo: {
            chamCong: '/bang-luong/dong-bo/cham-cong',
            kpi: '/bang-luong/dong-bo/kpi',
            xacThuc: '/bang-luong/dong-bo/xac-thuc',
        },
    },
    vanPhong: {
        donTu: {
            ...createAdminRouter('van-phong/', 'don-tu', 'id'),
            trangChu: '/van-phong/don-tu/trang-chu',
            thongKe: '/van-phong/don-tu/thong-ke',
        },
        quyTrinhDuyet: {
            ...createAdminRouter('van-phong/', 'quy-trinh-duyet', 'id'),
        },
        nghiPhep: {
            soDu: '/van-phong/nghi-phep/so-du',
            yeuCau: '/van-phong/nghi-phep/yeu-cau',
            lichSu: '/van-phong/nghi-phep/lich-su',
            chiTiet: '/van-phong/nghi-phep/chi-tiet/:id',
            choDuyet: '/van-phong/nghi-phep/cho-duyet',
        },
    },
    // Routes cho renderCode (product, material, asset, warehouse...)
    productCategory: createAdminRouter('admin/', 'product-category', 'id'),
    product: createAdminRouter('admin/', 'product', 'id'),
    material: createAdminRouter('admin/', 'material', 'id'),
    assetCategory: createAdminRouter('administrative/', 'asset-category', 'id'),
    asset: createAdminRouter('administrative/', 'asset', 'id'),
    warehouse: createAdminRouter('admin/', 'warehouse', 'id'),
    warehousePosition: createAdminRouter('admin/', 'warehouse-position', 'id'),
}

export default routerConstants

